import React, { useEffect, useRef, useState } from "react";

const APP_STORE_LINK = "https://apps.apple.com/fr/app/demeden/id6505034671";
const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.djammadev.demeden";
const LINKED_IN_LINK = "https://www.linkedin.com/company/djamma-dev";
const FACEBOOK_LINK = "https://www.facebook.com/djammadev";
const TWITTER_LINK = "https://twitter.com/djammadev";
const PRIVACY_FR = "https://demeden.djammadev.com/fr/privacy.html";
const PRIVACY_EN = "https://demeden.djammadev.com/en/privacy.html";
const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

const NAV = [
  { href: "#accueil", label: "Accueil" },
  { href: "#principe", label: "Principe" },
  { href: "#ecrans", label: "Écrans" },
  { href: "#contact", label: "Contact" },
];

const SCREENS = [
  {
    src: "/assets/img/screens/chats.png",
    title: "Conversation",
    caption: "La dépense s’écrit comme une phrase.",
  },
  {
    src: "/assets/img/screens/transaction.png",
    title: "Transaction",
    caption: "Montant, comptes et devise sont déjà remplis.",
  },
  {
    src: "/assets/img/screens/accounts.png",
    title: "Comptes",
    caption: "Chaque compte garde ce qui entre et ce qui sort.",
  },
  {
    src: "/assets/img/screens/login-1.png",
    title: "Connexion",
    caption: "Un code envoyé au téléphone ouvre la session.",
  },
];

const LEDGER = [
  { name: "Moi", detail: "main d’œuvre", amount: "−100 000 FCFA", direction: "out" },
  { name: "Maçon", detail: "main d’œuvre", amount: "+100 000 FCFA", direction: "in" },
  {
    name: "Construction",
    detail: "ciment, 2 tonnes",
    amount: "−220 000 FCFA",
    direction: "out",
  },
  {
    name: "Quincaillerie",
    detail: "ciment, 2 tonnes",
    amount: "+220 000 FCFA",
    direction: "in",
  },
];

function Icon({ name }) {
  const paths = {
    apple:
      "M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z",
    play: "M7 4.5v15l12.5-7.5L7 4.5z",
    facebook:
      "M14 8.5h2.2V6H14c-1.8 0-3 1.3-3 3.1V11H9v2.4h2V20h2.6v-6.6h2.1l.3-2.4h-2.4V9.4c0-.5.3-.9.9-.9z",
    linkedin:
      "M6.2 9.2H3.5V20h2.7V9.2zM4.8 4.2a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM20.5 13.3c0-2.8-1.5-4.1-3.5-4.1-1.6 0-2.4.9-2.8 1.5V9.2H11.5V20h2.7v-5.8c0-.3.1-.6.2-.9.3-.6.8-1.2 1.7-1.2 1.2 0 1.7.9 1.7 2.2V20h2.7v-6.7z",
    x: "M14.3 4h2.4L12 9.2 17.8 20h-4.4l-3.4-5-3.9 5H3.7l5.1-6.6L4.4 4h4.5l3.1 4.6L14.3 4zm-.8 14.4h1.3L8.6 5.5H7.2l6.3 12.9z",
  };

  return (
    <svg className="icon" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d={paths[name]} />
    </svg>
  );
}

function Logo({ className = "logo" }) {
  return (
    <img className={className} src="/logo.svg" alt="" width="40" height="40" />
  );
}

function StoreLinks() {
  return (
    <div className="store-row">
      <a className="store" href={APP_STORE_LINK} target="_blank" rel="noreferrer">
        <Icon name="apple" />
        <span>
          Télécharger
          <small>App Store</small>
        </span>
      </a>
      <a
        className="store store-ghost"
        href={PLAY_STORE_LINK}
        target="_blank"
        rel="noreferrer"
      >
        <Icon name="play" />
        <span>
          Télécharger
          <small>Play Store</small>
        </span>
      </a>
    </div>
  );
}

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="wrap header-bar">
        <a className="brand" href="#accueil" onClick={() => setOpen(false)}>
          <Logo />
          <span>Demebaga</span>
        </a>
        <button
          className="nav-toggle"
          type="button"
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen((value) => !value)}
        >
          {open ? "Fermer" : "Menu"}
        </button>
        <nav id="site-nav" className={open ? "site-nav is-open" : "site-nav"}>
          {NAV.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}

function Home() {
  return (
    <section id="accueil" className="hero">
      <div className="wrap hero-grid">
        <div>
          <p className="kicker">Votre assistant au quotidien</p>
          <h1>
            Écrivez la dépense.
            <span>Demebaga tient le registre.</span>
          </h1>
          <p className="lead">
            Une phrase suffit, ou la photo d’un reçu. Demebaga en tire le
            montant, la devise et les comptes, puis range l’opération.
          </p>
          <StoreLinks />
        </div>
        <div className="hero-visual">
          <img
            className="hero-shot"
            src="/assets/img/screens/chats.png"
            alt="Deux notes envoyées dans le chat : un achat de ciment et un paiement au maçon."
          />
          <article className="extract">
            <p>Lu dans la phrase</p>
            <strong>220 000 FCFA</strong>
            <span>Construction → Quincaillerie</span>
            <span>2 × 110 000</span>
          </article>
        </div>
      </div>
    </section>
  );
}

function Principle() {
  const steps = [
    {
      title: "Vous écrivez",
      text: "Dans le chat, comme vous le diriez à quelqu’un qui tient les comptes.",
    },
    {
      title: "Demebaga lit",
      text: "Il reconnaît le montant, la devise, l’expéditeur et le bénéficiaire.",
    },
    {
      title: "Le solde suit",
      text: "Chaque compte montre ce qui est entré, ce qui est sorti, et quand.",
    },
  ];

  return (
    <section id="principe" className="principle">
      <div className="wrap">
        <div className="section-head">
          <p className="kicker">Principe</p>
          <h2>De la phrase au solde</h2>
        </div>
        <ol className="steps">
          {steps.map((step, index) => (
            <li key={step.title}>
              <span>0{index + 1}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </li>
          ))}
        </ol>

        <div className="example-grid">
          <div className="notes">
            <h3>Deux notes</h3>
            <blockquote>
              Achat de 2 tonnes de ciment à 110 000 FCFA par tonne avec le
              compte Construction.
            </blockquote>
            <blockquote>
              J’ai envoyé 100 000 au maçon comme main d’œuvre.
            </blockquote>
          </div>
          <div>
            <h3>Quatre lignes de registre</h3>
            <ul className="ledger">
              {LEDGER.map((line) => (
                <li key={line.name}>
                  <span>
                    {line.name}
                    <small>{line.detail}</small>
                  </span>
                  <strong className={line.direction}>{line.amount}</strong>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

function Features() {
  const items = [
    {
      title: "Le langage de tous les jours",
      text: "Pas de formulaire à ouvrir pour noter. La phrase porte déjà l’opération.",
    },
    {
      title: "La photo du reçu",
      text: "Demebaga lit le texte du reçu, puis le traite comme un message.",
    },
    {
      title: "FCFA, euro, dollar",
      text: "Les comptes gardent leur devise. Les totaux réunissent les écritures équivalentes.",
    },
    {
      title: "Une question, plus tard",
      text: "Vous interrogez le registre, ou vous demandez un rappel à l’heure dite.",
    },
  ];

  return (
    <section className="features" aria-labelledby="features-title">
      <div className="wrap">
        <div className="section-head">
          <p className="kicker">Dans l’application</p>
          <h2 id="features-title">Ce que la note devient</h2>
        </div>
        <ul className="feature-grid">
          {items.map((item) => (
            <li key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function Screens() {
  const closeRef = useRef(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!active) {
      return undefined;
    }
    closeRef.current?.focus();
    const onKey = (event) => {
      if (event.key === "Escape") {
        setActive(null);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active]);

  return (
    <section id="ecrans" className="screens">
      <div className="wrap">
        <div className="section-head">
          <p className="kicker">Écrans</p>
          <h2>Regarder comment ça marche</h2>
        </div>
        <ul className="shot-grid">
          {SCREENS.map((screen) => (
            <li key={screen.src}>
              <button type="button" onClick={() => setActive(screen)}>
                <img src={screen.src} alt="" />
                <span>
                  <strong>{screen.title}</strong>
                  {screen.caption}
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
      {active && (
        <div
          className="lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={active.title}
          onClick={() => setActive(null)}
        >
          <div className="lightbox-card" onClick={(event) => event.stopPropagation()}>
            <button
              ref={closeRef}
              type="button"
              className="lightbox-close"
              onClick={() => setActive(null)}
            >
              Fermer
            </button>
            <img src={active.src} alt={active.caption} />
          </div>
        </div>
      )}
    </section>
  );
}

function Contact() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [notification, setNotification] = useState("");
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();
    const captcha = window.grecaptcha;
    if (!captcha) {
      setHasError(true);
      setNotification(
        "La vérification anti-robot n’est pas prête. Réessayez dans un instant."
      );
      return;
    }

    setLoading(true);
    setNotification("");
    captcha.ready(() => {
      captcha
        .execute(RECAPTCHA_KEY, { action: "submit" })
        .then(async (token) => {
          const data = {
            contact: {
              firstName,
              lastName,
              email,
              subject: "Contact : [Demebaga]",
              message,
            },
            captcha: token,
          };
          try {
            const res = await fetch("/api/data/contact", {
              headers: { "Content-Type": "application/json" },
              method: "POST",
              body: JSON.stringify(data),
            });
            const response = await res.json();
            if (res.status !== 200) {
              throw new Error(JSON.stringify(response));
            }
            setHasError(false);
            setNotification("Merci. Nous avons bien reçu votre message.");
            setFirstName("");
            setLastName("");
            setEmail("");
            setMessage("");
          } catch {
            setHasError(true);
            setNotification(
              "Une erreur est survenue lors de la communication avec le serveur."
            );
          } finally {
            setLoading(false);
          }
        })
        .catch(() => {
          setHasError(true);
          setNotification(
            "La vérification anti-robot a échoué. Réessayez dans un instant."
          );
          setLoading(false);
        });
    });
  };

  return (
    <section id="contact" className="contact">
      <div className="wrap contact-grid">
        <div>
          <p className="kicker">Contact</p>
          <h2 id="contact-title">Écrire à Djamma Dev</h2>
          <p>
            Une question sur Demebaga, ou l’envie d’être prévenu des prochaines
            versions. Laissez un message.
          </p>
        </div>
        <form aria-labelledby="contact-title" onSubmit={onSubmit} aria-busy={loading}>
          <div className="field">
            <label htmlFor="contact-first-name">Prénom</label>
            <input
              id="contact-first-name"
              name="given-name"
              autoComplete="given-name"
              value={firstName}
              onChange={(event) => setFirstName(event.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="contact-last-name">Nom</label>
            <input
              id="contact-last-name"
              name="family-name"
              autoComplete="family-name"
              required
              value={lastName}
              onChange={(event) => setLastName(event.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="contact-email">Adresse email</label>
            <input
              id="contact-email"
              name="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="contact-message">Message</label>
            <textarea
              id="contact-message"
              name="message"
              rows="5"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
            />
          </div>
          <button className="send" type="submit" disabled={loading}>
            {loading ? "Envoi…" : "Envoyer"}
          </button>
          {notification && (
            <p className={hasError ? "form-error" : "form-success"} role="alert">
              {notification}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}

function Footer() {
  const social = [
    { href: FACEBOOK_LINK, name: "facebook", label: "Djamma Dev sur Facebook" },
    { href: LINKED_IN_LINK, name: "linkedin", label: "Djamma Dev sur LinkedIn" },
    { href: TWITTER_LINK, name: "x", label: "Djamma Dev sur X" },
  ];

  return (
    <footer className="site-footer">
      <div className="wrap footer-bar">
        <p>
          Demebaga, par Djamma Dev
          <span> © {new Date().getFullYear()}</span>
        </p>
        <p className="footer-links">
          <a href={PRIVACY_FR}>Confidentialité (FR)</a>
          <a href={PRIVACY_EN}>Privacy (EN)</a>
        </p>
        <ul className="social">
          {social.map((item) => (
            <li key={item.href}>
              <a href={item.href} target="_blank" rel="noreferrer" aria-label={item.label}>
                <Icon name={item.name} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}

function App() {
  return (
    <>
      <a className="skip" href="#accueil">
        Aller au contenu
      </a>
      <Header />
      <main>
        <Home />
        <Principle />
        <Features />
        <Screens />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
